import { Component, OnInit, effect, inject } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { TranslationService } from '../../services/translation.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionVariable } from '../../enum/session-variable';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
    selector: 'taly-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit {

  transferSignal = inject(SharedSignalsService);
  toggleCurrentLanguage: boolean = false;
  isHeader: boolean = false;
  textDirection :string;

  constructor(public translationService: TranslationService, public authservice : AuthService, private storageService : LocalStorageService ) {

    effect(() => {
      this.isHeader = this.transferSignal?.showHeader();  
      this.textDirection = this.transferSignal.textDirection();   
    });
  }

  ngOnInit(): void {

  }

  toggleText() {
    this.toggleCurrentLanguage = !this.toggleCurrentLanguage;
    const currentLanguage = this.toggleCurrentLanguage ? 'ar-KW' : 'en-US'
    this.transferSignal.setTextDirection(currentLanguage == 'ar-KW' ? 'rtl' : 'ltr');
    this.storageService.setItem(SessionVariable.LANGUAGE, currentLanguage);
    this.translationService.switchLanguage(currentLanguage);
  }

  redirectBack() {
    this.transferSignal.setShowCancelOrderPopup(true)
  }

}